// extracted by mini-css-extract-plugin
export default {"termsTitle":"terms_termsTitle__WrNRP","termsPoint":"terms_termsPoint__0sOP6"};